import { ApiService } from "../../constants/ApiService";
import { HttpService } from "../../constants/HTTPService";
import { GetProfileDto } from "./Dto";
import { ProfileEntity } from "./Entity";

export const GetAccountData = async (accessToken?: string) => {
  const headers = new Headers();
  const bearer = `Bearer ${accessToken}`;

  headers.append("Authorization", bearer);

  const options = {
    method: "GET",
    headers,
  };

  return fetch(
    `https://graph.microsoft.com/v1.0/me?$select=mail,jobTitle,department,onPremisesExtensionAttributes,displayName`,
    options
  )
    .then((res) => res.json())
    .catch((error) => console.log(error));
};

const getProfileImage = async (accessToken) => {
  console.log("get profile image");
  const apiUrl = "https://graph.microsoft.com/v1.0/me/photo/$value";

  const headers = {
    Authorization: `Bearer ${accessToken}`,
  };

  const response = await fetch(apiUrl, {
    method: "GET",
    headers,
  });

  const imageBlob = await response.blob();
  return imageBlob;
};

const blobToBase64 = (blob) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.addEventListener("load", () => {
      resolve(reader.result);
    });
    // eslint-disable-next-line unicorn/prefer-add-event-listener
    reader.onerror = (error) => {
      reject(error);
    };
    reader.readAsDataURL(blob);
  });

export const fetchAndDisplayProfileImage = async (accessToken) => {
  try {
    const imageBlob = await getProfileImage(accessToken);
    const base64Image = await blobToBase64(imageBlob);
    return base64Image;
  } catch (error) {
    console.error("Error fetching or converting the profile image:", error);
    throw error;
  }
};

export const getProfileApiHc = async (binusianID: string) => {
  console.log("myapi", binusianID);
  const data = HttpService.get(`${ApiService.apiHc.getProfile}/${binusianID}`);
  const dataAPI = await data;

  return dataAPI.data;
};

export const getProfile = async (
  payload: GetProfileDto
): Promise<ProfileEntity> => {
  try {
    const response = await HttpService.post(
      ApiService.identity.getProfile,
      JSON.stringify(payload)
    );
    return ProfileEntity.fromJSON(response.data.data);
  } catch (error) {
    console.error("Error fetching profile:", error);
    throw new Error("Failed to fetch profile");
  }
};
